import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
function SmoothScroll({ children }) {
  const location = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") {
      const timeoutId = setTimeout(() => {
        document.getElementById("ScrollContainer").scrollTo({
          top: 0,
          behavior: "smooth", // Optional: for smooth scrolling
        });
      }, 0);

      // Cleanup timeout if the component unmounts before the timeout completes
      return () => clearTimeout(timeoutId);
    }
  }, [location]);
  return <>{children}</>;
}
export default SmoothScroll;
